module.exports = __webpack_public_path__ + "img/Wassertruppführer.4229336e.svg";